export default function (url: string): string {
  if (url.includes("mailto") || url.match(/^(http(s)?:)?\/\//i)) {
    return url;
  }
  return "https://" + url;
}
